import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// import { RootState } from '../store';
import { IManualOrder } from '../../../types/ManualOrder';
import { threeFourParser } from '../../utils/threeFourParser';
import { threeTwoParser } from '../../utils/threeTwoParser';
import { RootState } from '../store';

export interface IFmnParsingState {
  orderMapped?: Record<string, unknown>;
  parsedFNM?: IManualOrder;
  parsingFNM?: boolean;
  error?: string | Record<string, unknown>;
}

export const initialState: IFmnParsingState = {
  orderMapped: undefined,
  parsedFNM: undefined,
  parsingFNM: false,
  error: undefined,
};

export const parseFNMAsync = createAsyncThunk(
  'fmnParse/parseFNM',
  async (file: File, { rejectWithValue }) => {
    try {
      const name = file.name.toLowerCase();
      const isThreeTwoFile = name.includes('.fnm');
      const isThreeFourFile = name.includes('.xsd') || name.includes('.xml');
      if (isThreeTwoFile) {
        const result = await threeTwoParser(file);
        return result;
      }
      if (isThreeFourFile) {
        const result = await threeFourParser(file);
        return result;
      }
    } catch (err: any) {
      return rejectWithValue('Fetch Token: ' + err);
    }
  }
);

export const fmnParseSlice = createSlice({
  name: 'fmnParse',
  initialState,
  reducers: {
    clearParsedFNM: (state) => {
      state.parsingFNM = false;
      state.parsedFNM = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      // DOWNLOAD FILES
      .addCase(parseFNMAsync.pending, (state) => {
        state.parsingFNM = true;
      })
      .addCase(parseFNMAsync.fulfilled, (state: any, action: any) => {
        state.parsingFNM = false;
        state.parsedFNM = action.payload;
        state.error = undefined;
      })
      .addCase(parseFNMAsync.rejected, (state: any, action: any) => {
        state.parsingFNM = false;
        state.parsedFNM = undefined;
        state.error = action.payload;
      });
  },
});

export const { clearParsedFNM } = fmnParseSlice.actions;

export const selectParsedFNM = (state: RootState) => state.fmnParse.parsedFNM;

export default fmnParseSlice.reducer;
